/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { comparisonKeyArray, moduleKey } from '../constants/constants';
import { DataCollectorService } from './data_collector_services/data_collector_service.service';
import { isEmpty } from 'lodash';

const WindowObject: any = {_localStorage: {}};

@Injectable()
export class LocalStorageService {
    previousModulePayload: any = {};
    
    
    
    constructor(private _httpClient: HttpClient,
        private dataCollectorService: DataCollectorService) {}
        
    public get baseUrl(): string {
        return `${this.getLocalStorage('dc_api_url')}/api`;
    }
    get apiUrls(): any{
        return {
            metaDataUrl : `${this.baseUrl}/meta_data`,
            metaDataAllUrl : `${this.baseUrl}/meta_data/all`,
        }
    };

    isNullOrUndefined(value: any): boolean {
        if ((typeof value) === 'number' || (typeof value) === 'boolean') {
          return false;
        }
        return [null,undefined].includes(value);
    }

    public setLocalStorage(key,data): void {
        if(!this.isNullOrUndefined(data)){
            localStorage.setItem(key,typeof(data) == 'object' ? JSON.stringify(data):data);
            WindowObject._localStorage[key] = typeof(data) == 'object' ? JSON.stringify(data):data;
        }
    }

    public loadLocalStorageFromApi(): any{
        if(this.getLocalStorage('dc_api_url')){
            this._httpClient.get(`${this.getLocalStorage('dc_api_url')}/api/meta_data/all`).subscribe((response: any)=>{
                const filteredList = response.data.filter((data: any)=> data.key.toLowerCase().includes('cache'));
                if(filteredList.length){
                    for(const key of filteredList){
                        const storageObj = JSON.parse(key.value);
                        const localKeys = Object.keys(storageObj);
                        if(localKeys.length){
                            for(const localKey of localKeys){
                                this.setLocalStorage(localKey,storageObj[localKey]);
                            }
                        }
                    }
                }
            });
        }
    }

    checkIfKeyExist(storageKey: string): boolean{
        for(const key of comparisonKeyArray){
            if(storageKey.includes(key)) {
                return true;
            }
        }
    }

    constructMetaObject(module): any{
        if(Object.keys(moduleKey).includes(module)){
            const localValue = this.allStorage();
            let payload = {};
            let value = {};
            for(const key of Object.keys(localValue)){
                if(key.includes(module.toLowerCase()) && this.checkIfKeyExist(key) ){
                    value = {...value,[key]: localValue[key]};
                }
            }

            payload = {
                module: moduleKey[module.toUpperCase()],
                key: `${module}_CACHE`,
                value: JSON.stringify(value)
            };
            const currentModuleLocalStorage = this.previousModulePayload[module];
            const isNotSame = JSON.stringify(currentModuleLocalStorage) !== JSON.stringify(payload);
            if(isNotSame){
                const metaPayload = {meta_data:payload};
                    if(Object.keys(payload).length > 0){
                        this.dataCollectorService.postData(this.apiUrls.metaDataUrl,metaPayload).subscribe((response: any)=>{
                            window.sessionStorage.setItem('window_reloaded','false');
                            if(window.sessionStorage.getItem('router_navigation') !== 'true'){
                                this.loadLocalStorageFromApi();
                            }
                            this.previousModulePayload = {
                                ...this.previousModulePayload,
                                [module] : payload
                            };
                        });
                    }
            }
        }
    }

    returnStoredValue(value,key): any{
        let returnValue: any;
        if(typeof(value) === 'string' && value?.match(/{.*?}/) != null) {
            try {
                returnValue = JSON.parse(value);
            }
            catch(err) {
                returnValue = value;
            }
        }
        else{
            returnValue = value;
        }
        return returnValue;
    }

    public getLocalStorage(key): any{
        let returnValue: any;
        if(WindowObject._localStorage[key]){
            returnValue = this.returnStoredValue(WindowObject._localStorage[key],key);
        }else{
            returnValue = this.returnStoredValue(localStorage.getItem(key),key);
        }
        return returnValue;
    }

    public removeLocalStorage(key): any{
        localStorage.removeItem(key);
        delete  WindowObject._localStorage[key];
    }

    public removeAllLocalstorage(): any{
        localStorage.clear();
        sessionStorage.clear();
        WindowObject._localStorage = {};
    }

    public allStorage(): any{
        let archive = {};
        const  keys = Object.keys(localStorage);
        for(const key of keys){
            archive = {...archive,[key]:this.getLocalStorage(key)};
        }
        return archive;
    }

}
